export const FEATURE_NAME = '@vshosting/cdn/features/add-domain-dialog';
